(function() {
  'use strict';

  angular.module('ringbaPortal').directive('vueExportFileLoader', vueExportFileLoader);

  function vueExportFileLoader() {
    const directive = {
      restrict: 'EA',
      scope: true,
      controller: vueExportFileLoaderController,
      controllerAs: 'vm',
      bindToController: true,
      templateUrl: '/scripts/shared/components/vue-export-file-loader/vue-export-file-loader.view.html'
    };
    return directive;
  }

  function vueExportFileLoaderController(

  ) {
    'ngInject';
  }
})();
